import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import { PropTypes } from 'prop-types';
import React from 'react';
import { DropdownButton } from './button';
import { DropdownContextProvider } from './context';
import { DropdownItem } from './item';
import { DropdownMenu } from './menu';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var variantPath = getVariantPath({
  id: 'dropdown'
});
var Dropdown = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'div' : _ref$as,
      isOpen = _ref.isOpen,
      onChange = _ref.onChange,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "isOpen", "onChange", "children"]);

  return _jsx(DropdownContextProvider, {
    isMenuOpen: isOpen,
    onChange: onChange,
    children: _jsx(As, _objectSpread(_objectSpread({
      ref: ref,
      sx: {
        variant: variantPath('wrapper')
      }
    }, props), {}, {
      children: children
    }))
  });
});
Dropdown.propTypes = {
  /**
   * Set to true if menu should be opened on load
   */
  isOpen: PropTypes.bool,

  /**
   * Function occurs on any user created change.
   * Example: `onChange={(newValue, event) => console.log(newValue, event)}`
   */
  onChange: PropTypes.func
};
Dropdown.defaultProps = {
  isOpen: false,
  onChange: null
};
Dropdown.displayName = 'Dropdown';
export { Dropdown, DropdownButton, DropdownItem, DropdownMenu };